import i18n from '@/i18n';

export default [
  {
    path: '/verify-link/:key',
    name: 'verify-link',
    meta: {
      loadState: true,
      auth: false,
      isAuthPage: false,
      title: i18n.global.t('validating_email_link')
    },
    component: () => import('../../views/verifyLink/Index'),
  },
];
